(function () {
  'use strict';

  var controllers = new WeakMap();

  function controller(root) {
    var found = controllers.get(root);
    if (found) return found;
    var states = root.querySelector('[data-le-ember-states]');
    if (!states) return null;
    found = { root: root, states: states, mediaId: null, observer: null, path: states.dataset.path };
    controllers.set(root, found);
    return found;
  }

  function showMedia(control) {
    var root = control.root;
    if (!root.isConnected || !control.mediaId) return false;
    var shown = false;
    root.querySelectorAll('[data-product-slideshow]').forEach(function (gallery) {
      var target = gallery.querySelector('[data-media-id="' + control.mediaId + '"]');
      if (!target || !gallery.getClientRects().length) return;
      target.querySelectorAll('img[loading="lazy"]').forEach(function (image) { image.loading = 'eager'; });
      if (!gallery.classList.contains('flickity-enabled')) return;
      gallery.dispatchEvent(new CustomEvent('theme:image:change', { detail: { id: control.mediaId } }));
      var Flickity = window.themeVendor && window.themeVendor.Flickity;
      var instance = Flickity && typeof Flickity.data === 'function' ? Flickity.data(gallery) : null;
      if (instance) {
        var index = instance.cells.findIndex(function (cell) { return cell.element === target; });
        if (index >= 0) instance.select(index, false, true);
      }
      shown = true;
    });
    if (shown && control.observer) {
      control.observer.disconnect();
      control.observer = null;
    }
    return shown;
  }

  function selectMedia(control, mediaId) {
    control.mediaId = mediaId ? String(mediaId) : null;
    if (control.observer) {
      control.observer.disconnect();
      control.observer = null;
    }
    if (!control.mediaId || showMedia(control)) return;
    control.observer = new MutationObserver(function () {
      if (!control.root.isConnected) {
        control.observer.disconnect();
        control.observer = null;
        return;
      }
      showMedia(control);
    });
    control.root.querySelectorAll('[data-product-slideshow]').forEach(function (gallery) {
      control.observer.observe(gallery, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    });
  }

  function replaceFragment(root, source, selector) {
    var current = root.querySelector(selector);
    var replacement = source.content.querySelector(selector);
    if (current && replacement) current.replaceWith(replacement.cloneNode(true));
  }

  function activate(root, state, id, options) {
    var control = controller(root);
    if (!control || !root.isConnected || window.location.pathname !== control.path || !state || !/^\d+$/.test(String(id))) return false;
    var source = control.states.querySelector('[data-le-ember-state="' + id + '"]');
    var form = root.querySelector('form[data-product-form]');
    if (!source || !form) return false;
    var variantId = Number(id);
    var available = source.dataset.available === 'true';
    state.variantId = variantId;
    state.emberPrice = Number(source.dataset.price);
    state.emberAvailable = available;
    form.querySelectorAll('input[name="id"]').forEach(function (input) { input.value = String(id); });
    var mirror = root.querySelector('[data-le-variant-id]');
    if (mirror) mirror.value = String(id);
    root.querySelectorAll('input[data-le-ember-variant]').forEach(function (input) {
      input.checked = input.dataset.leEmberVariant === String(id);
    });
    replaceFragment(root, source, '.le-v2__price-block');
    replaceFragment(root, source, '.le-v2__stock-wrap');
    var button = root.querySelector('[data-le-main-atc]');
    var label = root.querySelector('[data-add-to-cart-text]');
    if (button) {
      button.disabled = !available;
      button.setAttribute('aria-label', source.dataset.buttonLabel);
    }
    if (label) label.textContent = source.dataset.buttonLabel;
    var notify = root.querySelector('[data-le-bis]');
    if (notify) notify.hidden = available;
    if (!options || options.history !== false) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', String(id));
      url.searchParams.delete('option_values');
      var historyState = Object.assign({}, window.history.state || {});
      if ('url' in historyState) historyState.url = url.toString();
      window.history.replaceState(historyState, '', url.toString());
    }
    var mediaId = options && options.hero ? (root.querySelector('[data-product-slideshow] [data-media-id]') || {}).dataset : null;
    selectMedia(control, mediaId ? mediaId.mediaId : source.dataset.mediaId);
    return true;
  }

  function stateFor(root) {
    var page = root.querySelector('.product-page');
    return page && window.Alpine && typeof window.Alpine.$data === 'function' ? window.Alpine.$data(page) : null;
  }

  function restoreFromLocation() {
    document.querySelectorAll('[data-le-ember]').forEach(function (root) {
      var control = controller(root);
      if (!control || window.location.pathname !== control.path) return;
      var id = new URL(window.location.href).searchParams.get('variant');
      activate(root, stateFor(root), id || control.states.dataset.defaultVariant, { history: false, hero: !id });
    });
  }

  window.LoveEcruEmber = {
    select: function (state, input) {
      var root = input && input.closest('[data-le-ember]');
      return !!root && activate(root, state, input.dataset.leEmberVariant);
    }
  };
  var pending = window.leEmberPendingSelection;
  if (pending) {
    window.leEmberPendingSelection = null;
    window.LoveEcruEmber.select(pending.state, pending.input);
  }
  window.addEventListener('popstate', restoreFromLocation);
  window.addEventListener('pageshow', function (event) { if (event.persisted) restoreFromLocation(); });
})();
